module.exports = __webpack_public_path__ + "img/attach-icon.c08a0bc2.svg";